import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, onMounted } from "vue";
interface Props {
  text: string;
  color: string;
  maxHeight?: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'Pill',
  props: {
    text: {},
    color: {},
    maxHeight: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const buttonRef = ref<HTMLButtonElement | null>();

onMounted(() => {
  if (props.maxHeight && buttonRef.value) {
    buttonRef.value.style.maxHeight = props.maxHeight;
  }
});

__expose({
  buttonRef,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    ref_key: "buttonRef",
    ref: buttonRef,
    class: "pill"
  }, _toDisplayString(__props.text), 513))
}
}

})